import React from "react";

import * as SC from "./Header.styled";
import { withRouter } from "react-router-dom";

import CampaignName from "./CampaignName/CampaignName";
import CampaignDuration from "./CampaignDuration/CampaignDuration";
import CampaignBudget from "./CampaignBudget/CampaignBudget";
import CampaignLocation from "./CampaignLocation/CampaignLocation";
import CampaignJobCategory from "./CampaignJobCategory/CampaignJobCategory";
import CampaignStatus from "./CampaignStatus/CampaignStatus";
import { withRefluxStore } from "../../../../Stores";
import DataVizStore from "../../../../Stores/DataVizStore";

const Header = ({
  isPrint = false,
  // Store
  campaignData,
  metricsToUse
}) => {
  const {
    campaignName,
    orgaName,
    campaignLiveDate,
    endDate,
    lifeTimeBudget,
    locations,
    status,
    jobCategoryId
  } = campaignData;

  return (
    <SC.Header>
      <div style={{ display: "flex", color: "white", padding: "10px 0px" }}>
        <SC.HeaderBox maxWidth="273px">
          <CampaignName isPrint={isPrint} campaignName={campaignName} orgaName={orgaName} />
        </SC.HeaderBox>
        <SC.HeaderBox>
          <CampaignDuration campaignLiveDate={campaignLiveDate} endDate={endDate} />
        </SC.HeaderBox>
        {!isPrint && (
          <SC.HeaderBox>
            <CampaignBudget lifeTimeBudget={lifeTimeBudget} metricsToUse={metricsToUse} />
          </SC.HeaderBox>
        )}
        <SC.HeaderBox maxWidth={"150px"}>
          <CampaignLocation locations={locations} />
        </SC.HeaderBox>
        <SC.HeaderBox>
          <CampaignJobCategory jobCategoryId={jobCategoryId} />
          {!isPrint && <CampaignStatus status={status} />}
        </SC.HeaderBox>
      </div>
    </SC.Header>
  );
};

export default withRouter(withRefluxStore(Header, [DataVizStore], ["metricsToUse"]));
